import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';

@Component({
  selector: 'app-ms-image',
  templateUrl: './ms-image.component.html',
  styleUrls: ['./ms-image.component.css'],
})
export class MsImageComponent implements OnChanges {
  @Input() imagemMsUrl?: string | null;
  @Input() alt = 'MS';
  @Input() width = '30%';
  isLoading = false;
  hasError = false;

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['imagemMsUrl']) {
      this.isLoading = !!this.imagemMsUrl;
      this.hasError = false;
    }
  }

  onLoad(): void {
    this.isLoading = false;
    this.hasError = false;
  }

  onError(): void {
    this.isLoading = false;
    this.hasError = true;
  }

  get imagemMsGpkgUrl(): string | null {
    const imagemUrl = this.imagemMsUrl;
    if (!imagemUrl) {
      return null;
    }

    const isBrasil = /\/uploads\/mapas\//i.test(imagemUrl);
    if (isBrasil) {
      const zipUrl = imagemUrl.replace(/\.png(?=($|\?))/i, '.zip');
      return zipUrl.replace(/\/(\d+)_([^/?]+\.zip)(\?.*)?$/i, '/$2$3');
    }

    return imagemUrl.replace(/\.png(?=($|\?))/i, '.gpkg');
  }

  get isBrasil(): boolean {
    return !!this.imagemMsUrl && /\/uploads\/mapas\//i.test(this.imagemMsUrl);
  }

  get nomeArquivoMsPng(): string {
    const imagemUrl = this.imagemMsUrl;
    if (!imagemUrl) {
      return 'ms.png';
    }

    const semQuery = imagemUrl.split('?')[0];
    return semQuery.substring(semQuery.lastIndexOf('/') + 1) || 'ms.png';
  }

  get nomeArquivoMsGpkg(): string {
    const gpkgUrl = this.imagemMsGpkgUrl;
    if (!gpkgUrl) {
      return 'ms.gpkg';
    }

    const semQuery = gpkgUrl.split('?')[0];
    return semQuery.substring(semQuery.lastIndexOf('/') + 1) || 'ms.gpkg';
  }

  downloadFile(url: string | null | undefined, fileName: string): void {
    if (!url) {
      return;
    }

    const link = document.createElement('a');
    link.href = url;
    link.download = fileName;
    link.rel = 'noopener';
    document.body.appendChild(link);
    link.click();
    link.remove();
  }
}
